/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./search_interfaces.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSolrSearchResults implements IDealerwareSolrSearchResults {
        // properties
        public static $inject: string[] = ['$q','$timeout'];
        public subject              :   any;
        public results              :   any;

        // Constructor
        constructor(public $q : any,public $timeout : any) {
            this.results = undefined;
            this.subject = undefined;
        }

        // Accessors
        get recordTotal() : number {
            return (this.isValid()) ? this.results.pagination.total : 0;
        }

        set recordTotal(t : number) {
            //don't do anything
        }

        get pageTotal() : number {
            return (this.isValid()) ? this.results.pagination.totalPages : 0;
        }

        set pageTotal(t : number) {
            // don't do anything since it comes from search results
        }

        get currentPage() : number {
            return (this.isValid()) ? this.results.pagination.currentPage : 0;
        }

        set currentPage(p : number) {
            // don't do anything handled in search results.
        }

        get hasNextPage() : boolean {
            return (this.isValid()) ? this.results.pagination.hasNextPage : false;
        }

        set hasNextPage(n : boolean) {
            // don't do anything, handled from results
        }

        get hasPreviousPage() : boolean {
            return (this.isValid()) ? this.results.pagination.hasPreviousPage : false;
        }

        set hasPreviousPage(p : boolean) {
            // don't do anything, handled from results.
        }

        //methods
        public getNextPage()      : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;
            if (this.isValid()) {
                if (this.hasNextPage) {
                    this.results.$nextPage({promise:true})
                        .then(
                            function(){
                                _deferred.resolve();
                            },
                            function(response : any) {
                                _deferred.reject(response);
                            }
                        );
                } else {
                    _deferred.reject({data: {message: 'No next page.'}});
                }
            } else {
                _deferred.reject({data: {message: 'No search results.'}});
            }
            return _deferred.promise;
        }

        public getPreviousPage()  : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;
            if (this.isValid()) {
                if (this.hasPreviousPage) {
                    this.results.$previousPage({promise:true})
                        .then(
                            function(){
                                _deferred.resolve();
                            },
                            function(response : any) {
                                _deferred.reject(response);
                            }
                        );
                } else {
                    _deferred.reject({data: {message: 'No previous page.'}});
                }
            } else {
                _deferred.reject({data: {message: 'No search results.'}});
            }
            return _deferred.promise;
        }

        public clear() : void {
            this.results = undefined;
            this.subject = undefined;
        }

        public isValid() : boolean {
            return  (
                this.results &&
                angular.isObject(this.results)
            ) ? true : false;
        }
    }

    getDealerwareWebServicesModule().service("dealerwareSolrSearchResults", DealerwareSolrSearchResults);
}